import {
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useEffect,
  useState,
} from "react";
import { Filters } from "@type/core/dashboard/dashboard.types";
import {
  FILTER_TYPE_DROPDOWN,
  FILTER_STATUS_DROPDOWN,
  initialFilters,
} from "@utils/Constant";
import StatusFilter from "@components/core/filters/StatusFilter";
import SearchFilter from "@components/core/filters/SearchFilter";
import DateFilter from "@components/core/filters/DateFilter";
import { useTranslation } from "react-i18next";
import ConfirmModal from "@components/core/modals/ConfirmModal";
import BasicButton from "@components/core/buttons/BasicButton";
import { Checkbox } from "antd";

interface DashboardFiltersProps {
  selectedFilters: Filters;
  setSelectedFilters: Dispatch<SetStateAction<Filters>>;
  className?: string;
}

const DashboardFilters: FunctionComponent<DashboardFiltersProps> = ({
  selectedFilters,
  setSelectedFilters,
  className = "",
}) => {
  const { t } = useTranslation();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);

  const [internSelectedFilters, setInternSelectedFilters] =
    useState<Filters>(selectedFilters);

  useEffect(() => {
    setInternSelectedFilters(selectedFilters);
  }, [selectedFilters]);

  const filters = {
    signature: FILTER_TYPE_DROPDOWN,
    cabinet: [],
    status: FILTER_STATUS_DROPDOWN,
  };

  return (
    <div className={`app-filters ${className}`}>
      <div className="filters-container">
        <StatusFilter
          filters={filters}
          selectedFilters={internSelectedFilters}
          setSelectedFilters={setInternSelectedFilters}
        />
        <SearchFilter
          selectedFilters={internSelectedFilters}
          setSelectedFilters={setInternSelectedFilters}
          onSearch={() => setSelectedFilters(internSelectedFilters)}
        />
        <DateFilter
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          internSelectedFilters={internSelectedFilters}
          setInternSelectedFilters={setInternSelectedFilters}
        />
      </div>
      <div className="filters-checkboxes">
        <Checkbox
          id="signatureCheck"
          checked={internSelectedFilters.signatureCheck}
          onChange={() => {
            if (
              !internSelectedFilters.scellementCheck &&
              internSelectedFilters.signatureCheck
            ) {
              setIsConfirmModalOpen(true);
            } else {
              setInternSelectedFilters({
                ...internSelectedFilters,
                signatureCheck: !internSelectedFilters.signatureCheck,
              });
            }
          }}
        >
          {t("home.dashboard.filters.signatureCheck")}
        </Checkbox>
        <Checkbox
          id="scellementCheck"
          checked={internSelectedFilters.scellementCheck}
          onChange={() => {
            if (
              internSelectedFilters.signatureCheck &&
              internSelectedFilters.scellementCheck
            ) {
              setIsConfirmModalOpen(true);
            } else {
              setInternSelectedFilters({
                ...internSelectedFilters,
                scellementCheck: !internSelectedFilters.scellementCheck,
              });
            }
          }}
        >
          {t("home.dashboard.filters.scellementCheck")}
        </Checkbox>
      </div>
      <div className="filters-actions">
        <BasicButton
          variant="transparent"
          text={t("home.dashboard.filters.resetCriteria")}
          className="mx-8"
          onClick={() => {
            setSelectedFilters(initialFilters);
            setInternSelectedFilters(initialFilters);
          }}
        />
        <BasicButton
          text={t("home.dashboard.filters.search")}
          className="mx-8"
          onClick={() => setSelectedFilters(internSelectedFilters)}
        />
      </div>
      <ConfirmModal
        visible={isConfirmModalOpen}
        onCancel={() => setIsConfirmModalOpen(false)}
        onOk={() => {
          setIsConfirmModalOpen(false);
          if (internSelectedFilters.signatureCheck) {
            setInternSelectedFilters({
              ...internSelectedFilters,
              signatureCheck: !internSelectedFilters.signatureCheck,
            });
          } else {
            setInternSelectedFilters({
              ...internSelectedFilters,
              scellementCheck: !internSelectedFilters.scellementCheck,
            });
          }
        }}
        title={t("home.dashboard.filters.confirmModal.title")}
        content={t("home.dashboard.filters.confirmModal.content")}
      />
    </div>
  );
};

export default DashboardFilters;
